import React, { useEffect, useState } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";

import { useNavigate, useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";

import Store from "../../../../zustand/store";
import { addSubscription, addUser } from "../../../../store/slice/userSlice";

import { BaseModal } from "../../../Modal/BaseModal";
import { apiCall } from "../../../../API/apiCall";
import { InstituteCreateSchema } from "../../../../schema/schema";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";

import DataTable from "../../../common/DataTable";
import AssignPlan from "./AssignPlan";
import ModalFormInstitute from "./ModalFormInstitute";
import { adminInstituteListColumns } from "../../../../utils/tableConfig";
import useDebounce from "../../../../hook/useDebounce";
import AddDomainsForm from "./AddDomainsForm";
import { useDispatch } from "react-redux";
import useFetch from "../../../../hook/useFetch";
import ImpersonationConfirmModal from "./ImpersonationConfirmModal";
import DeleteModal from "../../../common/DeleteModal";

const InstituteList = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(false);

  const [formError, setFormError] = useState({});

  const [institutes, setInstitutes] = useState([]);

  const [modalState, setModalState] = useState({
    type: null,
    open: false,
    formData: {
      _id: null,
      email: "",
      phone: "",
      instituteName: "",
      instituteType: null,
      isPlanCreated: false,
      professorDomain: "",
      studentDomain: "",
      origin: "",
    },
    originalData: {
      _id: null,
      email: "",
      phone: "",
      instituteName: "",
      instituteType: null,
      isPlanCreated: false,
      professorDomain: "",
      studentDomain: "",
    },
    changedFields: {},
  });

  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search.trim(), 1000);

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = searchParams.get("currentPage") || 1;
  const pageLimit = 5;

  const [paginationData, setPaginationData] = useState({
    totalCount: 0,
    currentPage: 0,
    totalPages: 0,
    previousPage: null,
    nextPage: null,
  });

  useEffect(() => {
    setIsLoading(true);
    getAllInstitutes(Number(currentPage), pageLimit);
  }, [currentPage, debounceValue]);

  const getAllInstitutes = async (page = currentPage, limit = pageLimit) => {
    try {
      const response = await apiCall({
        url: "/institute",
        method: "GET",
        params: {
          page,
          limit: limit || pageLimit,
          isDeleted: false,
          userType: "institute",
          searchValue: debounceValue,
          searchFields: "instituteName,Email,Mobile,Mobile",
        },
      });

      setInstitutes(response?.data?.data);
      setPaginationData(response?.pagination);
    } catch (error) {
      console.log("Error : ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = (type, item) => {
    setFormError({});
    setIsApiLoading(false);

    // if (type === "impersonate") {
    //   console.log("IIIIIIII : ", item);
    //   // setIsLoading(true);
    //   handleImpersonate(item);
    //   // navigate("/");
    //   return;
    // }

    const institutes = {
      _id: item?._id || null,
      email: item?.Email || "",
      phone: item?.Mobile || "",
      instituteName: item?.instituteName || "",
      instituteType: item?.instituteType || "",
      isPlanCreated: item?.isPlanCreated,
      professorDomain: item?.professorDomain || "",
      studentDomain: item?.studentDomain || "",
      origin: item?.origin || "",
    };

    setModalState({
      type,
      open: true,
      formData: institutes,
      originalData: type !== "delete" ? institutes : null,
      changedFields: {},
    });

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    setModalState({
      type: null,
      open: false,
      formData: {
        id: null,
      },
      changedFields: {},
    });
  };

  const handleInputChange = (field, value) => {
    setModalState((prevState) => {
      const isChanged = value !== prevState.originalData[field];

      return {
        ...prevState,
        formData: { ...prevState.formData, [field]: value },
        changedFields: { ...prevState.changedFields, [field]: isChanged },
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { type, formData, changedFields } = modalState;

    const error = InstituteCreateSchema({
      email: formData?.email,
      InstituteName: formData?.instituteName,
      InstituteType: formData?.instituteType,
      phone: formData?.phone,
    });

    if (Object.keys(error).length !== 0) {
      setFormError(error);
      return;
    }
    setIsApiLoading(true);

    let url = "institute";
    let config;

    switch (type) {
      case "createInstitute":
        {
          const {
            _id,
            instituteName,
            instituteType,
            professorDomain,
            studentDomain,
            ...dataWithoutId
          } = formData;

          const payload = {
            instituteName: instituteName,
            instituteType: instituteType,
            ...dataWithoutId,
          };
          payload.origin = "web";

          config = {
            url: `${url}/create-institute`,
            method: "POST",
            data: payload,
          };
        }
        break;
      case "editInstitute":
        {
          const payload = { instituteEmail: formData?.email };

          for (const field in changedFields) {
            if (changedFields[field]) {
              payload[field] = formData[field];
            }
          }

          config = {
            url: `${url}/edit-institute`,
            method: "PATCH",
            data: payload,
          };
        }
        break;
      case "addDomains":
        {
          const payload = { instituteEmail: formData?.email };

          for (const field in changedFields) {
            if (changedFields[field]) {
              payload[field] = formData[field];
            }
          }

          config = {
            url: `${url}/edit-institute`,
            method: "PATCH",
            data: payload,
          };
        }
        break;
      // --------------------------delete institute---------------------------
      // case "deleteInstitute":
      //   config = {
      //     url: `/institute/delete-Institute/${formData._id}`, // append _id in URL
      //     method: "DELETE",
      //   };
      //   break;
      // -----------------------------------------------------
    }

    try {
      const response = await apiCall(config);

      if (response.status || response.success) {
        toast.success(response.message);
        getAllInstitutes(Number(currentPage), pageLimit);
        handleCloseModal();
      }
    } catch (err) {
      setIsApiLoading(false);
    } finally {
      setIsApiLoading(false);
    }
  };

  const renderModalContent = () => {
    const isDisabled = !Object.values(modalState?.changedFields || {}).some(
      (field) => field,
    );

    switch (modalState.type) {
      case "createInstitute":
        return (
          <ModalFormInstitute
            type={"add"}
            data={modalState}
            handleCloseModal={handleCloseModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            formError={formError}
            isApiLoading={isApiLoading}
          />
        );
      case "editInstitute":
        return (
          <ModalFormInstitute
            type={"edit"}
            isDisabled={isDisabled}
            data={modalState}
            handleCloseModal={handleCloseModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            formError={formError}
            isApiLoading={isApiLoading}
          />
        );
      case "assignPlan":
        return (
          <AssignPlan
            data={modalState.formData}
            handleCloseModal={handleCloseModal}
            getAllInstitutes={getAllInstitutes}
          />
        );
      // ----------------------delete institute------------------------
      // case "deleteInstitute":
      //   return (
      //     <DeleteModal
      //       handleSubmit={handleSubmit}
      //       handleCloseModal={handleCloseModal}
      //       modalName={"Details"}

      //       // loading={loading}
      //     />
      //   );
      // ---------------------------------------------
      case "addDomains":
        return (
          <AddDomainsForm
            type={"add"}
            data={modalState}
            handleCloseModal={handleCloseModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            formError={formError}
            isDisabled={isDisabled}
          />
        );
      case "impersonate":
        return (
          <ImpersonationConfirmModal
            show={true}
            data={modalState?.formData}
            title="Confirm User Impersonation"
            onConfirm={handleCloseModal}
            onCancel={handleCloseModal}
          />
        );
      default:
        return null;
    }
  };

  const handletoggle = async (institueData) => {
    try {
      const config = {
        url: "institute/block",
        method: "PATCH",
        data: {
          instituteId: institueData._id,
        },
      };
      const response = await apiCall(config);

      if (response.success) {
        toast.success(response.message);
        getAllInstitutes(Number(currentPage), pageLimit);
      }
    } catch (err) {
      console.log("Error : ", err);
    }
  };

  const handlePageClick = (event) => {
    setSearchParams((prev) => {
      prev.set("currentPage", Number(event.selected) + 1);
      return prev;
    });
  };

  const handleSearchInputChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <>
      <>
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          sx={{
            mb: 2,
            mt: 2,
            p: 1,
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            boxShadow: 2,
            backgroundColor: "#f9f9f9",
          }}
        >
          <TextField
            label="Search"
            name="name"
            className="cstmSearchBox"
            value={search}
            onChange={handleSearchInputChange}
            error={!!formError?.name}
            helperText={formError?.name}
            sx={{
              flexGrow: 1,
              mb: { xs: 2, sm: 0 },
              width: "100%",
              minWidth: { xs: "100%", sm: "300px" },
              maxWidth: "300px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#1976d2",
                },
                "&:hover fieldset": {
                  borderColor: "#1565c0",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#0d47a1",
                },
              },
            }}
          />

          <Button
            variant="contained"
            onClick={() => handleOpenModal("createInstitute")}
            sx={{
              flexShrink: 0,
              height: "45px",
              minWidth: { xs: "100%", sm: "120px" },
              backgroundColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Add Institute +
          </Button>
        </Box>

        <Box sx={{ height: 450 }}>
          {isLoading ? (
            <Loader />
          ) : institutes?.length ? (
            <DataTable
              columns={adminInstituteListColumns}
              data={institutes}
              handleOpenModal={handleOpenModal}
              handletoggle={handletoggle}
            />
          ) : (
            <Typography
              variant="h5"
              color="text.secondary"
              sx={{
                textAlign: "center",
                mt: 4,
              }}
            >
              No record found
            </Typography>
          )}
        </Box>
      </>
      <div className="pagin pagination-blog mb-3">
        <ReactPaginate
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={
            isNaN(paginationData.totalPages) ? 1 : paginationData.totalPages
          }
          forcePage={Number(paginationData.currentPage - 1)}
          renderOnZeroPageCount={null}
          previousLabel="< previous"
          nextLabel="next >"
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          activeClassName="active"
        />
      </div>
      <BaseModal
        classname="base_modal_mui CstmBaseModalWidth"
        open={openModal}
        handleClose={handleCloseModal}
        maxWidth={600}
      >
        {renderModalContent()}
      </BaseModal>
    </>
  );
};

export default InstituteList;
